















import { Component, Prop, Vue } from "vue-property-decorator";
import Question from "@/components/Question.vue";
@Component({
  components: { Question }
})
export default class RemainingTime extends Vue {
  @Prop()
  endsAt!: number;

  @Prop()
  timeLimit!: number;
  now: number = new Date().getTime();

  get remainingTime() {
    const seconds = this.remainingSeconds;
    return Math.floor(seconds / 60.0) + "m " + (seconds % 60) + "s";
  }

  private get remainingSeconds() {
    return Math.floor(this.endsAt / 1000.0) - Math.floor(this.now / 1000.0);
  }

  get percent() {
    return (1 - this.remainingSeconds / (this.timeLimit * 60)) * 100;
  }

  mounted() {
    window.setInterval(() => {
      this.now = Math.trunc(new Date().getTime());
    }, 1000);
  }
}
